"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Palette_1 = require("../../styles/Palette");
const CssBaselineOverrides = {
    MuiCssBaseline: {
        defaultProps: {
            enableColorScheme: true,
        },
        styleOverrides: {
            body: {
                position: 'absolute',
                margin: '0px',
                overflow: 'hidden',
                top: '0px',
                bottom: '0px',
                width: '100%',
                backgroundColor: Palette_1.gray[100],
            },
        },
    },
};
exports.default = CssBaselineOverrides;
//# sourceMappingURL=CssBaselineOverrides.js.map